import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import BackButton from 'src/components/BackButton';
import DeleteButton from 'src/components/DeleteButton';
import Iconify from 'src/components/Iconify';
import WarningAlert from 'src/components/WarningAlert';

// Unmanaging takes effect as soon as it is confirmed and clears the environment default on the way
// out, so the dialog says what changes before the star flips.
const StopManagingBasePolicyDialog = ({ basePolicy, loading, onCancel, onConfirm }) => (
  <Dialog
    open
    onClose={onCancel}
    maxWidth="xs"
    fullWidth
    PaperProps={{ sx: { backgroundColor: 'background.dialog' } }}>
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Iconify icon="mdi:star-off-outline" width={22} height={22} color="#FFB84D" />
      Stop Managing Base Policy
    </DialogTitle>
    <DialogContent>
      <Stack gap={2}>
        <Stack spacing={0.25}>
          <Typography variant="body2" sx={{ color: '#F3F4F6', fontWeight: 600 }}>
            {basePolicy.policyName}
          </Typography>
          <Typography variant="caption" sx={{ color: '#9CA3AF' }}>
            {basePolicy.policyId}
          </Typography>
        </Stack>
        <WarningAlert sx={{ py: 0.25 }}>
          <Typography variant="caption">
            Supplemental policies and security catalogs can no longer be generated against this base
            policy, and it stops being the environment default. Devices already running it are not
            affected.
          </Typography>
        </WarningAlert>
        <Typography variant="body2" sx={{ color: '#ccc' }}>
          You can bring it back under management at any time. Its deployment settings and deployment
          tags are kept; the environment default is not.
        </Typography>
      </Stack>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <BackButton disabled={loading} onClick={onCancel}>
        Cancel
      </BackButton>
      <DeleteButton disabled={loading} onClick={onConfirm}>
        Stop Managing
      </DeleteButton>
    </DialogActions>
  </Dialog>
);

StopManagingBasePolicyDialog.propTypes = {
  basePolicy: PropTypes.shape({
    policyName: PropTypes.string,
    policyId: PropTypes.string,
  }).isRequired,
  loading: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default StopManagingBasePolicyDialog;
